import React from "react";
import { DetailShell } from "@/components/nds/windows/finance/parts";
import PaychecksTab from "@/components/nds/windows/finance/PaychecksTab";
import SplitTab from "@/components/nds/windows/finance/SplitTab";
import OutsideIncomeTab from "@/components/nds/windows/finance/OutsideIncomeTab";

const TABS = [
  { id: "paychecks", label: "Paychecks", Tab: PaychecksTab, tone: "financial", desc: "Logged paychecks and verification status" },
  { id: "split", label: "Split", Tab: SplitTab, tone: "data", desc: "How each paycheck is split across buckets" },
  { id: "outside_income", label: "Outside income", Tab: OutsideIncomeTab, tone: "comms", desc: "Income from outside the program" },
];

export default function FinPaycheckDetail({ resident, onBack }) {
  return <DetailShell prefix="fin-paycheck" tabs={TABS} resident={resident} onBack={onBack} />;
}
